import { useState, useEffect, useCallback } from 'react';
import './home.scss';
import Header from './header.jsx';
import ProductDisplay from './productdisplay.jsx';
import FilterOptions from './filteroptions.jsx';
import axios from 'axios';

function Home() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [priceRange, setPriceRange] = useState([0, Infinity]);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch products on mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/products`); // Use your actual API endpoint
        console.log('Fetched products:', response.data); // Log the fetched data

        const productsArray = response.data.$values ? response.data.$values : []; // Extract the array from $values
        setProducts(productsArray);
        setFilteredProducts(productsArray); // Initialize with all products
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  // Update filtered products when any filter changes
  useEffect(() => {
    const filterProducts = () => {
      let filtered = products;
      if (categories.length > 0) {
        filtered = filtered.filter(product => categories.some(category => category.includes(product.subcategory)));
      }
      if (searchQuery) {
        filtered = filtered.filter(product =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.subcategory.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
      if (priceRange) {
        const [minPrice, maxPrice] = priceRange;
        filtered = filtered.filter(product => {
          const productPrice = parseFloat(product.price.replace(/[^\d.]/g, '')) || 0; // Convert price to numeric value, default to 0 if NaN
          return productPrice >= minPrice && productPrice <= maxPrice;
        });
      }
      setFilteredProducts(filtered);
    };
  
    filterProducts();
    setCurrentPage(1); // Reset to page 1 when filters change
  }, [products, categories, searchQuery, priceRange]);
  

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleCategoryChange = (newCategories) => {
    setCategories(newCategories);
  };

  const handlePriceRangeChange = useCallback((range) => {
    setPriceRange(range);
  }, []);

  const resetFilters = () => {
    setCategories([]);
    setSearchQuery('');
    setPriceRange([0, Infinity]);
  };
  return (
    <section id="home">
      <Header onSearch={handleSearch} />
      <div className="main-content">
        <div className="filter-section">
          <FilterOptions
            setCategory={handleCategoryChange}
            setPriceRange={handlePriceRangeChange}
            resetFilters={resetFilters}
          />
        </div>
        <div className="product-section">
          <ProductDisplay products={filteredProducts} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </section>
  );
}

export default Home;
